import type { SerializedLinkNode } from "@lexical/link";
import { LinkNode } from "@lexical/link";
import type { EditorConfig, LexicalNode } from "lexical";
import { $applyNodeReplacement } from "lexical";

// This is not functionally different from a regular link node, but it is used to represent survey links specifically.
export class SurveyLinkNode extends LinkNode {
  static getType(): string {
    return "surveylink";
  }

  constructor(url: string, key?: string) {
    super(url, undefined, key);
    this.__url = url;
  }

  static clone(node: SurveyLinkNode): SurveyLinkNode {
    return new this(node.__url, node.__key);
  }

  createDOM(config: EditorConfig): HTMLElement {
    const dom = super.createDOM(config);
    dom.classList.add("survey-link");
    return dom;
  }

  updateDOM(
    prevNode: this,
    anchor: HTMLAnchorElement | HTMLSpanElement,
    config: EditorConfig,
  ): boolean {
    return super.updateDOM(prevNode, anchor, config);
  }

  static importJSON(serializedNode: SerializedLinkNode): SurveyLinkNode {
    return new this(serializedNode.url);
  }

  exportJSON(): SerializedLinkNode {
    return {
      ...super.exportJSON(),
      type: "surveylink",
    };
  }
}

export function $isSurveyLinkNode(node: LexicalNode | null | undefined): node is SurveyLinkNode {
  return node instanceof SurveyLinkNode;
}

export function $createSurveyLinkNode(surveyUrl: string): SurveyLinkNode {
  const node = new SurveyLinkNode(surveyUrl);
  return $applyNodeReplacement(node);
}
